import { sampleSize } from './collections';

export const isNullOrEmpty = (s: string | undefined | null): boolean => {
  return (s || '').length === 0;
};
export const isNullOrWhiteSpaces = (s: string | undefined | null): boolean => {
  return (s || '').trim().length === 0;
};

export const camelize = (str: string): string => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
};

export const titlelize = (str: string): string => {
  if ((str || '').length === 0) return str;
  return `${str[0].toUpperCase()}${str.slice(1)}`;
};

export const isValidUrl = (str: string | undefined): boolean => {
  if (isNullOrWhiteSpaces(str)) return false;
  let url;
  try {
    url = new URL(str!);
  } catch {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
};

export const guidIsNullOrEmpty = (guid: string): boolean => {
  if (isNullOrWhiteSpaces(guid) || guid === '00000000-0000-0000-0000-000000000000') {
    return true;
  } else {
    return false;
  }
};

export const replaceAll = (str: string, from: string, to: string) => {
  return str.split(from).join(to);
};

export const trimEnd = (str: string, char: string = ' ') => {
  return str.replace(new RegExp(`${char}+$`), '');
};

export const trimStart = (str: string, char: string = ' ') => {
  return str.replace(new RegExp(`^${char}+`), '');
};

export const trim = (str: string, char: string = ' ') => {
  return trimEnd(trimStart(str, char), char);
};

export const truncate = (txt: string, length: number): string => {
  return txt.length > length ? txt.substr(0, length - 1) + ' ...' : txt;
};

export const randomString = (n = 1, seed = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890') => {
  return sampleSize([...seed], n).join('');
};

export const isEmail = (str: string | undefined | null): boolean => {
  if (isNullOrWhiteSpaces(str) || str!.length < 3) return false;
  const input = document.createElement('input');

  input.type = 'email';
  input.required = true;
  input.value = str!;

  const result =
    typeof input.checkValidity === 'function'
      ? input.checkValidity()
      : /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
          str!
        );
  input.remove();
  return result;
};

export const isPersonalEmailAddress = (email: string | undefined | null): boolean => {
  if (!isEmail(email)) return false;

  const personalEmailDomains: string[] = [
    'gmail.com',
    'outlook.com',
    'outlook.es',
    'yahoo.com',
    'yahoo.es',
    'hotmail.com',
    'hotmail.es',
    'aol.com',
    'icloud.com',
    'msn.com',
    'zoho.com',
    'mail.com',
    'protonmail.com',
    'gmx.com',
    'live.com',
    'yandex.com',
    'inbox.com',
    'fastmail.com',
    'me.com',
    'mac.com'
  ];

  const domain = email!.split('@').pop();

  return personalEmailDomains.includes(domain!.toLowerCase());
};
